import _ from 'lodash';
import React, { Fragment } from 'react';
import autobind from 'autobind-decorator';
import { browserConfig } from 'client/shared/config';
import { inject, observer } from 'mobx-react';
import FacebookProvider, { Login } from 'react-facebook';

import SignUpButton from './sign-up-button';
// import TermsLink from '../terms-link';

@inject('userStore')
class FacebookButton extends React.Component {
	@autobind
	handleResponse ({ profile }) {
		const { userStore } = this.props;

		FB.api(
			`/${profile.id}/picture?redirect=false&type=large`,
			'GET', {},
			({ data }) => {

				userStore.newFBUserData = {
					profileImage: data.url,
					...profile
				};

				userStore.addMemberModalOpen = true;
			}
		);
	}

	@autobind
	handleError (error) {
		console.log(error);
		this.setState({ error });
	}

	render() {
		return (
			<FacebookProvider appId={ browserConfig.fb.appID }>
				<Login
					scope="public_profile,email"
					onResponse={ this.handleResponse }
					onError={ this.handleError }
				>
					<button style={{minWidth: '15vw'}} className="button neo facebook">Sign Up With Facebook</button>
				</Login>
				<br />
			</FacebookProvider>
		);
	}
}

const SignUpSection = (props) => {
	const { includeFB = false, onEmailSignUpClick, modalType = 'artist' } = props;

	return (
		<div style={{marginTop: '6vh'}}>
			{ (includeFB ? <FacebookButton />: null) }

			<SignUpButton
				onClick={ onEmailSignUpClick }
				modalType={ modalType }
			/>
			
		</div>
	);
};

export default SignUpSection;
